import { BrotliDecode } from './brotli_decode'
import { inflate } from 'pako'

import * as chat from '..'
import * as chatModels from '../models'

import protoRoot from '../../proto/douyin/proto'
import protobuf from 'protobufjs'
import {getUuid4Hex} from "@/utils";

const HEADER_SIZE = 16

export const WS_BODY_PROTOCOL_VERSION_NORMAL = 0
export const WS_BODY_PROTOCOL_VERSION_HEARTBEAT = 1
export const WS_BODY_PROTOCOL_VERSION_DEFLATE = 2
export const WS_BODY_PROTOCOL_VERSION_BROTLI = 3

export const OP_HANDSHAKE = 0
export const OP_HANDSHAKE_REPLY = 1
export const OP_HEARTBEAT = 2
export const OP_HEARTBEAT_REPLY = 3
export const OP_SEND_MSG = 4
export const OP_SEND_MSG_REPLY = 5
export const OP_DISCONNECT_REPLY = 6
export const OP_AUTH = 7
export const OP_AUTH_REPLY = 8
export const OP_RAW = 9
export const OP_PROTO_READY = 10
export const OP_PROTO_FINISH = 11
export const OP_CHANGE_ROOM = 12
export const OP_CHANGE_ROOM_REPLY = 13
export const OP_REGISTER = 14
export const OP_REGISTER_REPLY = 15
export const OP_UNREGISTER = 16
export const OP_UNREGISTER_REPLY = 17
// B站业务自定义OP
// export const MinBusinessOp = 1000
// export const MaxBusinessOp = 10000

export const AUTH_REPLY_CODE_OK = 0
export const AUTH_REPLY_CODE_TOKEN_ERROR = -101

const HEARTBEAT_INTERVAL = 10 * 1000
const RECEIVE_TIMEOUT = HEARTBEAT_INTERVAL + (5 * 1000)
let RECEIVE_MSG_TIMEOUT = HEARTBEAT_INTERVAL + (50 * 1000)

let textEncoder = new TextEncoder()
let textDecoder = new TextDecoder()

export default class ChatClientOfficialBase {

  constructor() {
    this.CMD_CALLBACK_MAP = {}

    this.onAddText = null
    this.onAddGift = null
    this.onAddMember = null
    this.onAddSuperChat = null
    this.onDelSuperChat = null
    this.onUpdateTranslation = null

    this.onFatalError = null

    this.needInitRoom = true
    this.xfdNeedInitRoom = true
    this.websocket = null
    this.xfdWebsocket = null
    this.retryCount = 0
    this.xfdRetryCount = 0
    this.totalRetryCount = 0
    this.xfdTotalRetryCount = 0
    this.isDestroying = false
    this.xfdIsDestroying = false
    this.heartbeatTimerId = null
    this.xfdHeartbeatTimerId = null
    this.receiveTimeoutTimerId = null
    this.xfdReceiveTimeoutTimerId = null

    this.roomOwnerAuthCode = null
    this.skin = null
  }

  async start() {
    await this.startGame()

    /*const retryTimes = 10;
    for (let a = 0; a < retryTimes; a++) {
      await this.startGame()

      debugger
      let dyWssUrl = this.getWsUrl()
      if (dyWssUrl !== undefined && dyWssUrl.indexOf('douyin.com/webcast/im/push/v2/') > 0) {
        break
      }
      this.sleep(5000)
    }*/

    this.skin = this.getSkin()
    this.wsConnect()
    this.xfdWsConnect()
  }

  sleep(delay) {
    const start = (new Date()).getTime()
    while((new Date()).getTime() - start < delay) {
      continue
    }
  }

  stop() {
    this.isDestroying = true
    if (this.websocket) {
      this.websocket.close()
    }
  }

  xfdStop() {
    this.xfdIsDestroying = true
    if (this.xfdWebsocket) {
      this.xfdWebsocket.close()
    }
  }

  async initRoom() {
    throw Error('Not implemented')
  }

  sendAuth() {
    throw Error('Not implemented')
  }

  async wsConnect() {
    if (this.isDestroying) {
      return
    }

    await this.onBeforeWsConnect()
    if (this.isDestroying) {
      return
    }

    this.websocket = new WebSocket(this.getWsUrl())
    this.websocket.binaryType = 'arraybuffer'
    this.websocket.onopen = this.onWsOpen.bind(this)
    this.websocket.onclose = this.onWsClose.bind(this)
    this.websocket.onmessage = this.onWsMessage.bind(this)
  }

  async xfdWsConnect() {
    if (this.xfdIsDestroying) {
      return
    }

    this.xfdWebsocket = new WebSocket(this.getXfdWsUrl())
    this.xfdWebsocket.binaryType = 'arraybuffer'
    this.xfdWebsocket.onopen = this.xfdOnWsOpen.bind(this)
    this.xfdWebsocket.onclose = this.xfdOnWsClose.bind(this)
    this.xfdWebsocket.onmessage = this.xfdOnWsMessage.bind(this)
  }

  async onBeforeWsConnect() {
    if (!this.needInitRoom) {
      return
    }

    let res
    try {
      res = await this.initRoom()
    } catch (e) {
      res = false
      console.error('initRoom exception:', e)
      if (e instanceof chat.ChatClientFatalError && this.onFatalError) {
        this.stop()
        this.onFatalError(e)
      }
    }

    if (!res) {
      this.onWsClose()
      throw Error('initRoom failed')
    }
    this.needInitRoom = false
  }

  startGame(){
    throw Error('Not implemented')
  }

  getWsUrl() {
    throw Error('Not implemented')
  }

  getXfdWsUrl() {
    throw Error('Not implemented')
  }

  getSkin() {
    throw Error('Not implemented')
  }

  onWsOpen() {
    this.heartbeatTimerId = window.setInterval(this.sendHeartbeat.bind(this), HEARTBEAT_INTERVAL)
    // 服务器心跳包，包含人气值，这里没用
    this.refreshReceiveTimeoutTimer()
  }

  xfdOnWsOpen() {
    this.xfdHeartbeatTimerId = window.setInterval(this.xfdSendHeartbeat.bind(this), HEARTBEAT_INTERVAL)
    // 服务器心跳包，包含人气值，这里没用
    this.xfdRefreshReceiveTimeoutTimer()
  }

  sendHeartbeat() {
    this.websocket.send(new Uint8Array([58, 2, 104, 98]))
  }

  xfdSendHeartbeat() {
    this.xfdWebsocket.send(new Uint8Array([58, 2, 104, 98]))
  }

  refreshReceiveTimeoutTimer() {
    if (this.receiveTimeoutTimerId) {
      window.clearTimeout(this.receiveTimeoutTimerId)
    }
    this.receiveTimeoutTimerId = window.setTimeout(this.onReceiveTimeout.bind(this), RECEIVE_TIMEOUT)
  }

  xfdRefreshReceiveTimeoutTimer() {
    if (this.xfdReceiveTimeoutTimerId) {
      window.clearTimeout(this.xfdReceiveTimeoutTimerId)
    }
    this.xfdReceiveTimeoutTimerId = window.setTimeout(this.xfdOnReceiveTimeout.bind(this), RECEIVE_TIMEOUT)
  }

  onReceiveTimeout() {
    console.warn('接收心跳消息超时,超时时间：' + RECEIVE_TIMEOUT)
    this.discardWebsocket()
  }

  xfdOnReceiveTimeout() {
    console.warn('xfd接收心跳消息超时,超时时间：' + RECEIVE_TIMEOUT)
    this.xfdDiscardWebsocket()
  }

  discardWebsocket() {
    if (this.receiveTimeoutTimerId) {
      window.clearTimeout(this.receiveTimeoutTimerId)
      this.receiveTimeoutTimerId = null
    }

    // 直接丢弃阻塞的websocket，不等onclose回调了
    this.websocket.onopen = this.websocket.onclose = this.websocket.onmessage = null
    this.websocket.close()
    this.onWsClose()
  }

  xfdDiscardWebsocket() {
    if (this.xfdReceiveTimeoutTimerId) {
      window.clearTimeout(this.xfdReceiveTimeoutTimerId)
      this.xfdReceiveTimeoutTimerId = null
    }

    // 直接丢弃阻塞的websocket，不等onclose回调了
    this.xfdWebsocket.onopen = this.xfdWebsocket.onclose = this.xfdWebsocket.onmessage = null
    this.xfdWebsocket.close()
    this.xfdOnWsClose()
  }

  onWsClose() {
    this.websocket = null
    if (this.heartbeatTimerId) {
      window.clearInterval(this.heartbeatTimerId)
      this.heartbeatTimerId = null
    }
    if (this.receiveTimeoutTimerId) {
      window.clearTimeout(this.receiveTimeoutTimerId)
      this.receiveTimeoutTimerId = null
    }

    if (this.isDestroying) {
      return
    }
    this.retryCount++
    this.totalRetryCount++
    console.warn(`掉线重连中 retryCount=${this.retryCount}, totalRetryCount=${this.totalRetryCount}`)

    // 防止无限重连的保险措施。120次重连大概会断线2000秒，没有收到消息重试时间大概2小时，应该够了，如果关播两小时内部开播接收不到新消息则需要刷新页面了
    if (this.totalRetryCount > 240) {
      this.stop()
      let error = new chatModels.ChatClientFatalError(
        chatModels.FATAL_ERROR_TYPE_TOO_MANY_RETRIES, 'The connection has lost too many times'
      )
      this.msgHandler.onFatalError(error)
      return
    }

    this.delayReconnect()
  }

  xfdOnWsClose() {
    this.xfdWebsocket = null
    if (this.xfdHeartbeatTimerId) {
      window.clearInterval(this.xfdHeartbeatTimerId)
      this.xfdHeartbeatTimerId = null
    }
    if (this.xfdReceiveTimeoutTimerId) {
      window.clearTimeout(this.xfdReceiveTimeoutTimerId)
      this.xfdReceiveTimeoutTimerId = null
    }

    if (this.xfdIsDestroying) {
      return
    }
    this.xfdRetryCount++
    this.xfdTotalRetryCount++
    console.warn(`xfd掉线重连中 xfdRetryCount=${this.xfdRetryCount}, xfdTotalRetryCount=${this.xfdTotalRetryCount}`)

    // 防止无限重连的保险措施。120次重连大概会断线2000秒，没有收到消息重试时间大概2小时，应该够了，如果关播两小时内部开播接收不到新消息则需要刷新页面了
    if (this.xfdTotalRetryCount > 480) {
      this.xfdStop()
      return
    }

    this.xfdDelayReconnect()
  }

  delayReconnect() {
    if (document.visibilityState === 'visible') {
      window.setTimeout(this.wsConnect.bind(this), this.getReconnectInterval())
      return
    }

    // 页面不可见就先不重连了，即使重连也会心跳超时
    let listener = () => {
      if (document.visibilityState !== 'visible') {
        return
      }
      document.removeEventListener('visibilitychange', listener)
      this.wsConnect()
    }
    document.addEventListener('visibilitychange', listener)
  }

  xfdDelayReconnect() {
    if (document.visibilityState === 'visible') {
      window.setTimeout(this.xfdWsConnect.bind(this), this.xfdGetReconnectInterval())
      return
    }

    // 页面不可见就先不重连了，即使重连也会心跳超时
    let xfdListener = () => {
      if (document.visibilityState !== 'visible') {
        return
      }
      document.removeEventListener('xfdVisibilitychange', xfdListener)
      this.xfdWsConnect()
    }
    document.addEventListener('xfdVisibilitychange', xfdListener)
  }

  getReconnectInterval() {
    // 不用retryCount了，防止意外的连接成功，导致retryCount重置
    let interval = Math.min(1000 + ((this.totalRetryCount - 1) * 2000), 20 * 1000)
    // 加上随机延迟，防止同时请求导致雪崩
    interval += Math.random() * 3000
    return interval
  }

  xfdGetReconnectInterval() {
    // 不用retryCount了，防止意外的连接成功，导致retryCount重置
    let interval = Math.min(1000 + ((this.xfdTotalRetryCount - 1) * 2000), 20 * 1000)
    // 加上随机延迟，防止同时请求导致雪崩
    interval += Math.random() * 3000
    return interval
  }

  onWsMessage(event) {
    // 服务器心跳包，包含人气值，这里没用
    this.refreshReceiveTimeoutTimer()

    if (!(event.data instanceof ArrayBuffer)) {
      console.warn('未知的websocket消息类型，data=', event.data)
      return
    }
    try {
      const buf = protobuf.util.newBuffer(event.data)
      const douyin_websocket_frame = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_websocket_frame')
      const douyin_websocket_frame_data = douyin_websocket_frame.decode(buf)
      // console.log(douyin_websocket_frame_data)

      let headers = douyin_websocket_frame_data.headersList
      let gzipFlag = false
      if (headers.compress_type === 'gzip') {
        gzipFlag = true
      }

      // 压缩过的先解压
      let payload = gzipFlag ? inflate(douyin_websocket_frame_data.payload) : douyin_websocket_frame_data.payload
      // console.log(payload)

      const douyin_websocket_frame_msg = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_websocket_frame_msg')
      const douyin_websocket_frame_msg_data = douyin_websocket_frame_msg.decode(payload)
      // console.log(douyin_websocket_frame_msg_data)

      // console.log(douyin_websocket_frame_msg_data.needAck)
      // console.log(douyin_websocket_frame_msg_data.messagesList)


      // 是否需要回复ack
      if (douyin_websocket_frame_msg_data.needAck) {
        let ext = douyin_websocket_frame_msg_data.internalExt;
        const req = {
          payloadType: 'ack',
          payload: this.returnAckArray(ext),
          logId: douyin_websocket_frame_data.logId
        }
        // console.log(req)
        let sendMsg = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_websocket_frame').encode(req).finish()
        // console.log(sendMsg)
        this.websocket.send(sendMsg)
      }

      douyin_websocket_frame_msg_data.messagesList.forEach((message) => {
        this.nextBuf(message)
      })

    } catch (err) {
      console.warn("onWsMessage:" + err)
    }

    /*let data = new Uint8Array(event.data)
    this.parseWsMessage(data)*/

    // 至少成功处理1条消息
    this.retryCount = 0
  }

  xfdOnWsMessage(event) {
    // 服务器心跳包，包含人气值，这里没用
    this.xfdRefreshReceiveTimeoutTimer()

    console.warn('xfdOnWsMessage收到消息，data=', event.data)

    // 至少成功处理1条消息
    this.xfdRetryCount = 0
  }

  returnAckArray(e) {
    const t = []
    for (const i of e) {
      const e = i.charCodeAt(0)
      e < 128
          ? t.push(e)
          : e < 2048
              ? (t.push(192 + (e >> 6)), t.push(128 + (63 & e)))
              : e < 65536 && (t.push(224 + (e >> 12)), t.push(128 + ((e >> 6) & 63)), t.push(128 + (63 & e)))
    }
    return Uint8Array.from(t)
  }

  nextBuf(message) {
    let command = {
      cmd: '',
      data: {
        room_id: null,
        uid: null,
        open_id: null,
        uname: null,
        msg: null,
        msg_id: null,
        fans_medal_level: null,
        fans_medal_name: null,
        fans_medal_wearing_status: null,
        guard_level: null,
        timestamp: null,
        uface: null,
        emoji_img_url: null,
        dm_type: null,

        gift_id: null,
        gift_icon: null,
        gift_name: null,
        gift_num: null,
        combo_gift: null,
        price: null,
        paid: null,

        giftMessageDataAnchorInfo: {
          uid: null,
          open_id: null,
          uname: null,
          uface: null
        },

        giftMessageDataComboInfo: {
          combo_base_num: null,
          combo_count: null,
          combo_id: null,
          combo_timeout: null
        }

      }
    }
    let method = message.method
    try {
      switch (method) {
        // 进入
        case 'WebcastMemberMessage':
          const douyin_webcast_member_message_msg = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_webcast_member_message_msg')
          const douyin_webcast_member_message_msg_data = douyin_webcast_member_message_msg.decode(message.payload)
          // console.log(douyin_webcast_member_message_msg_data)
          break
        // 关注
        case 'WebcastSocialMessage':
          const douyin_webcast_social_message_msg = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_webcast_social_message_msg')
          const douyin_webcast_social_message_msg_data = douyin_webcast_social_message_msg.decode(message.payload)
          // console.log(douyin_webcast_social_message_msg_data)
          break
        // 聊天
        case 'WebcastChatMessage':

          try {
            const douyin_webcast_chat_message_msg = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_webcast_chat_message_msg')
            const douyin_webcast_chat_message_msg_data = douyin_webcast_chat_message_msg.decode(message.payload)
            // console.log(douyin_webcast_chat_message_msg_data)

            let guardLevel = 0
            try {
              let badgeLevel = douyin_webcast_chat_message_msg_data.user.fansClub.data.level
              if (badgeLevel > 5 && badgeLevel <= 10) {
                guardLevel = 3
              } else if (badgeLevel > 10 && badgeLevel <= 15) {
                guardLevel = 2
              } else if (badgeLevel > 15) {
                guardLevel = 1
              }
            } catch (err) {
              console.warn("WebcastChatMessage:" + err)
            }


            command.cmd = 'LIVE_OPEN_PLATFORM_DM'
            command.data.uname = douyin_webcast_chat_message_msg_data.user.nickname
            command.data.uid = 0
            command.data.open_id = douyin_webcast_chat_message_msg_data.user.id
            command.data.uface = douyin_webcast_chat_message_msg_data.user.avatarThumb.urlListList[0]
            command.data.timestamp = new Date().getTime()
            // 待完善
            command.data.room_id = this.roomOwnerAuthCode
            command.data.msg = douyin_webcast_chat_message_msg_data.content
            command.data.msg_id = getUuid4Hex()
            command.data.guard_level = guardLevel
            command.data.fans_medal_wearing_status = false
            try {
              command.data.fans_medal_name = douyin_webcast_chat_message_msg_data.user.fansClub.data.clubName
              command.data.fans_medal_level = douyin_webcast_chat_message_msg_data.user.fansClub.data.level
              command.data.fans_medal_wearing_status = true
            } catch (err) {
              console.warn("WebcastChatMessage:" + err)
            }

            command.data.emoji_img_url = ''
            command.data.dm_type = 0

            // console.log('弹幕消息，command=', command)

            this.handlerCommand(command)

          } catch (err) {
            console.warn("WebcastChatMessage:" + err)
          }

          break
        // 点赞
        case 'WebcastLikeMessage':
          const douyin_webcast_like_message_msg = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_webcast_like_message_msg')
          const douyin_webcast_like_message_msg_data = douyin_webcast_like_message_msg.decode(message.payload)
          // console.log(douyin_webcast_like_message_msg_data)
          break
        // 礼物
        case 'WebcastGiftMessage':

          try {
            const douyin_webcast_gift_message_msg = protoRoot.lookup('com.pioneer.common.barrage.douyin.protobuf.douyin_webcast_gift_message_msg')
            const douyin_webcast_gift_message_msg_data = douyin_webcast_gift_message_msg.decode(message.payload)
            // console.log(douyin_webcast_gift_message_msg_data)
            if (this.calculateGiftCount(douyin_webcast_gift_message_msg_data) < 1) {
              break
            }

            let guardLevelGift = 0
            try {
              let badgeLevelGift = douyin_webcast_gift_message_msg_data.user.fansClub.data.level
              if (badgeLevelGift > 5 && badgeLevelGift <= 10) {
                guardLevelGift = 3
              } else if (badgeLevelGift > 10 && badgeLevelGift <= 15) {
                guardLevelGift = 2
              } else if (badgeLevelGift > 15) {
                guardLevelGift = 1
              }
            } catch (err) {
              console.warn("WebcastGiftMessage:" + err)
            }


            command.cmd = 'LIVE_OPEN_PLATFORM_SEND_GIFT'
            // 待完善
            command.data.room_id = this.roomOwnerAuthCode

            command.data.uid = 0
            command.data.open_id = douyin_webcast_gift_message_msg_data.user.id
            command.data.uname = douyin_webcast_gift_message_msg_data.user.nickname
            command.data.uface = douyin_webcast_gift_message_msg_data.user.avatarThumb.urlListList[0]
            command.data.gift_name = douyin_webcast_gift_message_msg_data.gift.name
            command.data.gift_id = douyin_webcast_gift_message_msg_data.longGiftId
            command.data.gift_num = this.calculateGiftCount(douyin_webcast_gift_message_msg_data)
            command.data.price = douyin_webcast_gift_message_msg_data.gift.diamondCount * 100

            command.data.paid = true

            command.data.fans_medal_wearing_status = false
            try {
              command.data.fans_medal_level = douyin_webcast_gift_message_msg_data.user.fansClub.data.level
              command.data.fans_medal_name = douyin_webcast_gift_message_msg_data.user.fansClub.data.clubName
              command.data.fans_medal_wearing_status = true
            } catch (err) {
              console.warn("WebcastGiftMessage:" + err)
            }

            command.data.guard_level = guardLevelGift
            command.data.timestamp = new Date().getTime()
            command.data.msg_id = getUuid4Hex()

            command.data.giftMessageDataAnchorInfo.uid = 0
            // 待完善 暂时用不上后续再说，获取当前主播的信息即可
            /*command.data.giftMessageDataAnchorInfo.open_id = douyin_webcast_gift_message_msg_data.toUser.id
            command.data.giftMessageDataAnchorInfo.uname = douyin_webcast_gift_message_msg_data.toUser.nickname
            command.data.giftMessageDataAnchorInfo.uface = douyin_webcast_gift_message_msg_data.toUser.avatarThumb.urlListList[0]*/

            command.data.gift_icon = douyin_webcast_gift_message_msg_data.gift.icon.urlListList[0]
            command.data.combo_gift = false

            command.data.giftMessageDataComboInfo.combo_base_num = this.calculateGiftCount(douyin_webcast_gift_message_msg_data)
            command.data.giftMessageDataComboInfo.combo_count = this.calculateGiftCount(douyin_webcast_gift_message_msg_data)
            command.data.giftMessageDataComboInfo.combo_id = ''
            command.data.giftMessageDataComboInfo.combo_timeout = 3

            // console.log('礼物消息，command=', command)



            if (this.skin.url && this.skin.fonts.length === 0 ){
              // 是弹幕样式
              // console.log("此皮肤是弹幕，本次触发弹幕的送礼消息")
              this.handlerCommand(command)
            } else if (!this.skin.url && this.skin.fonts.length > 0){
              // console.log("此皮肤是送礼动画，本次触发送礼动画消息")

              // 舰长 200-1000  提督1000-2000  总督2000以上
              // 是否符合大航海，如果是大航海构建大航海消息
              let commandGuard = {
                cmd: '',
                data: {
                  user_info: {
                    uid: null,
                    open_id: null,
                    uname: null,
                    uface: null
                  },
                  gift_name: null,
                  guard_level: null,
                  guard_num: null,
                  guard_unit: null,
                  price: null,
                  fans_medal_level: null,
                  fans_medal_name: null,
                  fans_medal_wearing_status: null,
                  timestamp: null,
                  room_id: null,
                  msg_id: null
                }
              }

              if (command.data.price >= 198000) {
                commandGuard.cmd = 'LIVE_OPEN_PLATFORM_GUARD'
                //
                commandGuard.data.gift_name = douyin_webcast_gift_message_msg_data.gift.name
                commandGuard.data.room_id = this.roomOwnerAuthCode
                commandGuard.data.price = douyin_webcast_gift_message_msg_data.gift.diamondCount * 100
                commandGuard.data.msg_id = getUuid4Hex()
                commandGuard.data.user_info.uface = douyin_webcast_gift_message_msg_data.user.avatarThumb.urlListList[0]
                commandGuard.data.timestamp = new Date().getTime()
                commandGuard.data.user_info.uname = douyin_webcast_gift_message_msg_data.user.nickname

                // 舰长 大于等于198-小于等于1000  提督大于1000-小于等于2000  总督大于2000以上
                // 对应的大航海等级 1总督 2提督 3舰长
                if (command.data.price >= 198000 && command.data.price <= 1000000) {
                  // 舰长 198-1000
                  commandGuard.data.guard_level = 3
                } else if (command.data.price > 1000000 && command.data.price <= 2000000) {
                  // 提督1000-2000
                  commandGuard.data.guard_level = 2
                } else if (command.data.price > 2000000) {
                  // 总督2000以上
                  commandGuard.data.guard_level = 1
                }

                commandGuard.data.guard_num = command.data.gift_num
                commandGuard.data.guard_unit = ''
                commandGuard.data.fans_medal_wearing_status = false
                try {
                  commandGuard.data.fans_medal_level = douyin_webcast_gift_message_msg_data.user.fansClub.data.level
                  commandGuard.data.fans_medal_name = douyin_webcast_gift_message_msg_data.user.fansClub.data.clubName
                  commandGuard.data.fans_medal_wearing_status = true
                } catch (err) {
                  console.warn("Guard：WebcastGiftMessage:" + err)
                }

                // console.log('大航海消息，commandGuard=', commandGuard)
              }

              /**
               * 如果当前皮肤只包含送礼
               * 只包含上舰
               * 有送礼和上舰
               */

              // 是送礼上舰动画样式
              if (this.skin.data.gift && (this.skin.data.captain && this.skin.data.admiral && this.skin.data.governor)) {
                // 包含送礼和上舰
                // 上舰不为空时不触发送礼
                if (commandGuard.cmd === 'LIVE_OPEN_PLATFORM_GUARD') {
                  // console.log("此皮肤包含送礼和上舰，本次触发上舰消息")
                  this.handlerCommand(commandGuard)
                } else {
                  // console.log("此皮肤包含送礼和上舰，本次触发送礼消息")
                  this.handlerCommand(command)
                }
              } else if (this.skin.data.gift && (!this.skin.data.captain && !this.skin.data.admiral && !this.skin.data.governor)) {
                // 只有送礼没上舰
                // console.log("此皮肤只包含送礼，本次触发送礼消息")
                this.handlerCommand(command)
              } else if (!this.skin.data.gift && (this.skin.data.captain && this.skin.data.admiral && this.skin.data.governor)) {
                // 只有上舰没送礼
                // console.log("此皮肤只包含上舰")
                if (commandGuard.cmd === 'LIVE_OPEN_PLATFORM_GUARD') {
                  // console.log("此皮肤只包含上舰，本次触发上舰消息")
                  this.handlerCommand(commandGuard)
                } else {
                  // console.log("此皮肤只包含上舰，本次未达到触发上舰消息")
                }
              }

            }

          } catch (err) {
            console.warn("WebcastGiftMessage:" + err)
          }
          break
        // 直播间统计
        case 'WebcastRoomUserSeqMessage':

          break
      }


    } catch (err) {
      // console.warn(err)
    }
  }

  calculateGiftCount(douyin_webcast_gift_message_msg_data) {
    let giftCount
    if (douyin_webcast_gift_message_msg_data.gift.combo && douyin_webcast_gift_message_msg_data.repeatEnd !== 1) {// 连击中
      return 0;
    }
    let comboCount = douyin_webcast_gift_message_msg_data.comboCount;
    if (douyin_webcast_gift_message_msg_data.groupCount !== 1) {// 每点击一次送礼的数量不是1时
      comboCount = douyin_webcast_gift_message_msg_data.groupCount * comboCount
    }
    giftCount = comboCount
    return giftCount
  }

  handlerCommand(command) {
    let cmd = command.cmd || ''
    let pos = cmd.indexOf(':')
    if (pos != -1) {
      cmd = cmd.substr(0, pos)
    }
    let callback = this.CMD_CALLBACK_MAP[cmd]
    if (callback) {
      callback.call(this, command)
    }
  }
}
